import { render, staticRenderFns } from "./ChangeIssueStatusButton.vue?vue&type=template&id=3988cbc4&scoped=true"
import script from "./ChangeIssueStatusButton.vue?vue&type=script&lang=js"
export * from "./ChangeIssueStatusButton.vue?vue&type=script&lang=js"
import style0 from "./ChangeIssueStatusButton.vue?vue&type=style&index=0&id=3988cbc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3988cbc4",
  null
  
)

export default component.exports